var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-vita--grid-area-section" },
    [
      _c("div", [_vm._v(_vm._s(_vm.section.title) + ":")]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.section.matching
            ? _c(
                "div",
                { staticClass: "job-vita--grid-area-section-matching-icon" },
                [
                  _c("Icon", {
                    attrs: {
                      icon: _vm.matchingIcon.icon,
                      color: _vm.matchingIcon.color
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.section.predefinedValue
            ? _c(
                "div",
                [
                  _c("PredefinedValue", {
                    attrs: { "predefined-value": _vm.section.predefinedValue }
                  })
                ],
                1
              )
            : _vm.section.text
            ? _c("div", { domProps: { innerHTML: _vm._s(_vm.section.text) } })
            : _vm._l(_vm.filteredItems, function(item) {
                return _c("application-job-vita-grid-area-section-item", {
                  key: item.id,
                  attrs: {
                    item: item,
                    "job-profile-id": _vm.jobProfileId,
                    "pseudonym-id": _vm.pseudonymId
                  },
                  on: { upgrade: _vm.onUpgrade }
                })
              }),
          _vm._v(" "),
          _vm.section.furtherItemsCount
            ? _c(
                "div",
                { staticClass: "color-green mt-1" },
                [
                  _vm.section.furtherItemsCountText
                    ? [_vm._v(_vm._s(_vm.section.furtherItemsCountText))]
                    : [
                        _vm._v(
                          "Die Person hat bisher mehr als " +
                            _vm._s(_vm.furtherItemsCountCapped) +
                            " weitere\n\t\t\t\t" +
                            _vm._s(_vm.section.furtherItemsCountLabel) +
                            " gesammelt.\n\t\t\t"
                        )
                      ],
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("Kontaktiere sie, um mehr darüber zu erfahren.\n\t\t")
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.section.extraPayload && _vm.section.extraPayload.type === "salary"
            ? _c("div", { staticClass: "pl-2" }, [
                _vm._v(
                  "\n\t\t\tIn Österreich ist es verpflichtend in Stellenausschreibungen das laut Kollektivvertrag\n\t\t\tvorgesehene Mindestgehalt anzugeben, welches du\n\t\t\t"
                ),
                _c(
                  "a",
                  {
                    attrs: { href: "#", target: "_blank" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.showCollectiveSalary = true
                      }
                    }
                  },
                  [_vm._v("hier")]
                ),
                _vm._v(
                  " findest.\n\t\t\tAchtung: das angebotene Gehalt liegt darüber.\n\t\t"
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.showCollectiveSalary
        ? _c(
            "PopUp",
            {
              attrs: {
                title: "Gehalt laut Kollektivvertrag",
                "ok-text": "OK",
                "hide-cancel": ""
              },
              on: {
                ok: function($event) {
                  _vm.showCollectiveSalary = false
                },
                hidden: function($event) {
                  _vm.showCollectiveSalary = false
                }
              }
            },
            [
              _vm._v(
                "\n\t\tDas Mindestgehalt laut Kollektivvertrag/Tarif beträgt auf Basis Vollzeit\n\t\t" +
                  _vm._s(
                    _vm._f("moneyAmount")(_vm.section.extraPayload.collective)
                  ) +
                  "."
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n\t\tNatürlich kann je nach Qualifikation und Möglichkeit im Unternehmen ein höheres Gehalt vereinbart werden.\n\t"
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showUpgradePopUp
        ? _c("UpgradePopUp", {
            attrs: {
              "job-profile-id": _vm.jobProfileId,
              "pseudonym-id": _vm.pseudonymId
            },
            on: {
              upgrade: _vm.onUpgrade,
              hidden: function($event) {
                _vm.showUpgradePopUp = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }